import { HarmonyClient } from './_internal/client';
export function createHarmonyClient(options) {
    return HarmonyClient.create(options);
}
//# sourceMappingURL=client.js.map